import DashboardPage from '../views/clientviews/Dashboardclient';
import PatientList from '../views/clientviews/Patientmanagment/patientlist'; 
import Speciality from '../views/clientviews/speciality'; 
import StaffList from '../views/clientviews/staffmanagment/stafflist'; 
import NewAppointment from '../views/clientviews/appointmentmanagment/addappointment'; 
import Patientfilemedical from '../views/clientviews/Patientmanagment/patientmedicalfile'; 
import Medicalhistory from '../views/clientviews/Patientmanagment/patientmedicalhistory'; 
import PaymentCaisse from '../views/clientviews/billingmanagement/payment'; 
import ReceiptPayment from '../views/clientviews/billingmanagement/receipt'; 
import Department from '../views/clientviews/deparmentmanagment/department'; 
import HospitalSetting from '../views/hospitalsetting'; 
import LocationSetting from '../views/Hospitalconfiguration/locationlist.js'; 
import PatientCard from '../views/clientviews/Patientmanagment/patientcard'; 
import Appointments from '../views/Doctorinterface/appointment.js';
import AppointmentHistory from '../views/Doctorinterface/appointement_history.js';
import MedicalAppointments from '../views/Doctorinterface/patientDetail.js';
import CalendarWeekView from '../views/Doctorinterface/calendar.js';
import StaffDetails from '../views/clientviews/staffmanagment/user'; 
import StaffSchedule from '../views/clientviews/staffmanagment/horaire'; 
import StaffScheduleEdit from '../views/clientviews/staffmanagment/horaireedit'; 
import telMed from '../views/clientviews/telemedecine/tele'; 
import Ordonnance from '../views/clientviews/telemedecine/appointment/ordornance'; 
import Appoint from '../views/clientviews/telemedecine/appointment/appoint'; 
import Appointmentprocess from '../views/clientviews/appointmentmanagment/appointment'; 
import Doctoragenda from '../views/clientviews/appointmentmanagment/timetable'; 
import Patientdontknow from '../views/clientviews/appointmentmanagment/patient'; 
import Schedulerdv from '../views/clientviews/appointmentmanagment/schedulerdv'; 
import Editappointment from '../views/clientviews/appointmentmanagment/editappointment.js';
import PrintbillingTicket from '../views/clientviews/billingmanagement/billingTicket.js'; 
import RoomsList from '../views/roomManagment/roomList';
import Summaryhospitalization from '../views/roomManagment/summaryhospitalization.js';
import AppointmentlistNurses from '../views/clientviews/appointmentmanagment/appointmentlist'; 
import SignvitalForm from '../views/clientviews/appointmentmanagment/Signvital'; 
import DoctorDashboard from '../views/Doctorinterface/dashboard.js'; 
import DoctorPatientDetails from '../views/Doctorinterface/patientDetail.js'; 
import DoctorCalendar from '../views/Doctorinterface/calendar.js'; 
import DoctorAppointment from '../views/Doctorinterface/appointment.js'; 
import DoctorHistory from '../views/Doctorinterface/appointement_history.js'; 
import DoctorIntakeConsult from '../views/new/docteur.js'; 
import Consultaiondetails from '../views/new/consultationdetails.js'; 
import Ordonnancegenerate from '../views/new/ordonnancegenerate.js'; 
import Infirmier from '../views/new/infirmier';
import Docteur from '../views/new/docteur';
import Paymentlist from '../views/clientviews/billingmanagement/allpaymentlist'; 
import InvoiceAssurance from '../views/clientviews/billingmanagement/caisiere/culture'; 
import Generalcongig from '../views/Hospitalconfiguration/generalconfig'; 
import HospitalDashboard from '../views/Rapport/repport.js';
import EditLocation from '../views/Hospitalconfiguration/edithospital.js';
import HospitalDetails from '../views/Hospitalconfiguration/hospitaldetails.js';
import PatientDataPrivacy from '../views/clientviews/Patientmanagment/patientPrivacy.js';
import StaffPlan from '../views/clientviews/staffmanagment/staffschedule.js';
import RolePermissionManager from '../views/clientviews/rolemanagement/rolemanage.js';
import withSubscriptionGuard from './withSubscriptionGuard';

// Protection de tous les composants avec withSubscriptionGuard
const ProtectedDashboard = withSubscriptionGuard(DashboardPage, 'Dashboard');
const ProtectedPatientList = withSubscriptionGuard(PatientList, 'Patient management');
const ProtectedSpeciality = withSubscriptionGuard(Speciality, 'Hospital settings');
const ProtectedStaffList = withSubscriptionGuard(StaffList, 'Staff management');
const ProtectedNewAppointment = withSubscriptionGuard(NewAppointment, 'Appointment scheduling');
const ProtectedPatientfilemedical = withSubscriptionGuard(Patientfilemedical, 'Medical history');
const ProtectedMedicalhistory = withSubscriptionGuard(Medicalhistory, 'Medical history');
const ProtectedPaymentCaisse = withSubscriptionGuard(PaymentCaisse, 'Billing');
const ProtectedReceiptPayment = withSubscriptionGuard(ReceiptPayment, 'Billing');
const ProtectedDepartment = withSubscriptionGuard(Department, 'Location settings');
const ProtectedHospitalSetting = withSubscriptionGuard(HospitalSetting, 'Hospital settings');
const ProtectedLocationSetting = withSubscriptionGuard(LocationSetting, 'Location settings');
const ProtectedPatientCard = withSubscriptionGuard(PatientCard, 'Appointment scheduling');
const ProtectedAppointments = withSubscriptionGuard(Appointments, 'Appointment scheduling');
const ProtectedAppointmentHistory = withSubscriptionGuard(AppointmentHistory, 'Appointment scheduling');
const ProtectedMedicalAppointments = withSubscriptionGuard(MedicalAppointments, 'Appointment scheduling');
const ProtectedCalendarWeekView = withSubscriptionGuard(CalendarWeekView, 'Schedule management');
const ProtectedStaffDetails = withSubscriptionGuard(StaffDetails, 'Schedule management');
const ProtectedStaffSchedule = withSubscriptionGuard(StaffSchedule, 'Schedule management');
const ProtectedStaffScheduleEdit = withSubscriptionGuard(StaffScheduleEdit, 'Schedule management');
const ProtectedTelMed = withSubscriptionGuard(telMed, 'Appointment scheduling');
const ProtectedOrdonnance = withSubscriptionGuard(Ordonnance, 'Appointment scheduling');
const ProtectedAppoint = withSubscriptionGuard(Appoint, 'Appointment scheduling');
const ProtectedAppointmentprocess = withSubscriptionGuard(Appointmentprocess, 'Appointment scheduling');
const ProtectedDoctoragenda = withSubscriptionGuard(Doctoragenda, 'Appointment scheduling');
const ProtectedPatientdontknow = withSubscriptionGuard(Patientdontknow, 'Appointment scheduling');
const ProtectedSchedulerdv = withSubscriptionGuard(Schedulerdv, 'Appointment scheduling');
const ProtectedEditappointment = withSubscriptionGuard(Editappointment, 'Appointment scheduling');
const ProtectedPrintbillingTicket = withSubscriptionGuard(PrintbillingTicket, 'Billing');
const ProtectedRoomsList = withSubscriptionGuard(RoomsList, 'Room management');
const ProtectedSummaryhospitalization = withSubscriptionGuard(Summaryhospitalization, 'Room management');
const ProtectedAppointmentlistNurses = withSubscriptionGuard(AppointmentlistNurses, 'Appointment scheduling');
const ProtectedSignvitalForm = withSubscriptionGuard(SignvitalForm, 'Appointment scheduling');
const ProtectedDoctorDashboard = withSubscriptionGuard(DoctorDashboard, 'Dashboard');
const ProtectedDoctorPatientDetails = withSubscriptionGuard(DoctorPatientDetails, 'Appointment scheduling');
const ProtectedDoctorCalendar = withSubscriptionGuard(DoctorCalendar, 'Appointment scheduling');
const ProtectedDoctorAppointment = withSubscriptionGuard(DoctorAppointment, 'Appointment scheduling');
const ProtectedDoctorHistory = withSubscriptionGuard(DoctorHistory, 'Appointment scheduling');
const ProtectedDoctorIntakeConsult = withSubscriptionGuard(DoctorIntakeConsult, 'Appointment scheduling');
const ProtectedConsultaiondetails = withSubscriptionGuard(Consultaiondetails, 'Appointment scheduling');
const ProtectedOrdonnancegenerate = withSubscriptionGuard(Ordonnancegenerate, 'Appointment scheduling');
const ProtectedInfirmier = withSubscriptionGuard(Infirmier, 'Appointment scheduling');
const ProtectedDocteur = withSubscriptionGuard(Docteur, 'Appointment scheduling');
const ProtectedPaymentlist = withSubscriptionGuard(Paymentlist, 'Billing');
const ProtectedInvoiceAssurance = withSubscriptionGuard(InvoiceAssurance, 'Billing');
const ProtectedGeneralcongig = withSubscriptionGuard(Generalcongig, 'Hospital settings');
const ProtectedHospitalDashboard = withSubscriptionGuard(HospitalDashboard, 'Reports and Analytics');
const ProtectedEditLocation = withSubscriptionGuard(EditLocation, 'Location settings');
const ProtectedHospitalDetails = withSubscriptionGuard(HospitalDetails, 'Hospital settings');
const ProtectedPatientDataPrivacy = withSubscriptionGuard(PatientDataPrivacy, 'Manage data');
const ProtectedStaffPlan = withSubscriptionGuard(StaffPlan, 'Staff management');
const ProtectedRolePermissionManager = withSubscriptionGuard(RolePermissionManager, 'Role management');

// Exportation de tous les composants protégés
export {
  ProtectedDashboard,
//   ProtectedPasswordModify,
  ProtectedPatientList,
  ProtectedSpeciality,
  ProtectedStaffList,
  ProtectedNewAppointment,
  ProtectedPatientfilemedical,
  ProtectedMedicalhistory,
  ProtectedPaymentCaisse,
  ProtectedReceiptPayment,
  ProtectedDepartment,
  ProtectedHospitalSetting,
  ProtectedLocationSetting,
  ProtectedPatientCard,
  ProtectedAppointments,
  ProtectedAppointmentHistory,
  ProtectedMedicalAppointments,
  ProtectedCalendarWeekView,
  ProtectedStaffDetails,
  ProtectedStaffSchedule,
  ProtectedStaffScheduleEdit,
  ProtectedTelMed,
  ProtectedOrdonnance,
  ProtectedAppoint,
  ProtectedAppointmentprocess,
  ProtectedDoctoragenda,
  ProtectedPatientdontknow,
  ProtectedSchedulerdv,
  ProtectedEditappointment,
  ProtectedPrintbillingTicket,
  ProtectedRoomsList,
  ProtectedSummaryhospitalization,
  ProtectedAppointmentlistNurses,
  ProtectedSignvitalForm,
  ProtectedDoctorDashboard,
  ProtectedDoctorPatientDetails,
  ProtectedDoctorCalendar,
  ProtectedDoctorAppointment,
  ProtectedDoctorHistory,
  ProtectedDoctorIntakeConsult,
  ProtectedConsultaiondetails,
  ProtectedOrdonnancegenerate,
  ProtectedInfirmier,
  ProtectedDocteur,
  ProtectedPaymentlist,
  ProtectedInvoiceAssurance,
  ProtectedGeneralcongig,
  ProtectedHospitalDashboard,
  ProtectedEditLocation,
  ProtectedHospitalDetails,
  ProtectedPatientDataPrivacy,
  ProtectedStaffPlan,
  ProtectedRolePermissionManager
};
